module.exports = __webpack_public_path__ + "static/media/woocommerce-enabled.91abb82c.png";